import { Api, Auth } from '../services'

export const fetchArticle = (params, slug) => {
    return Api.get( '/wp/article/' + slug, params, ( data, error ) => {
        if( error ) {
            console.log('error', error)
            return '';
        }

        return data;
    })
}

export const fetchRecommendedArticles = (params, slug) => {
    return Api.get( '/wp/article/' + slug + '/recommended', params, ( data, error ) => {
        if( error ) return {}

        return data;
    })
}


// WEBPACK FOOTER //
// ./src/js/api/article.js